import { atom } from "jotai";
import { PortfolioTab } from '@/hooks/modals/usePortfolioOpen';

interface PortfolioOpenState {
  isOpen: boolean;
  selectedTab: PortfolioTab;
}

export const portfolioOpenAtom = atom<PortfolioOpenState>({
  isOpen: false,
  selectedTab: 'portfolio'
});

export const openPortfolioAtom = atom(
  (get) => get(portfolioOpenAtom).isOpen,
  (get, set) => {
    set(portfolioOpenAtom, {
      ...get(portfolioOpenAtom),
      isOpen: true
    });
  }
);

export const closePortfolioAtom = atom(
  (get) => get(portfolioOpenAtom).isOpen,
  (get, set) => {
    set(portfolioOpenAtom, {
      ...get(portfolioOpenAtom),
      isOpen: false
    });
  }
);

export const togglePortfolioAtom = atom(
  (get) => get(portfolioOpenAtom).isOpen,
  (get, set) => {
    set(portfolioOpenAtom, {
      ...get(portfolioOpenAtom),
      isOpen: !get(portfolioOpenAtom).isOpen
    });
  }
);

export const selectedTabAtom = atom<PortfolioTab>(
  (get) => get(portfolioOpenAtom).selectedTab
);

export const setSelectedTabAtom = atom(
  (get) => get(selectedTabAtom),
  (get, set, newTab: PortfolioTab) => {
    set(portfolioOpenAtom, {
      ...get(portfolioOpenAtom),
      selectedTab: newTab
    });
  }
);